export default {
  'Choose File': '選擇文件',
  'Please paste a URL': '輸入一個影片URL鏈接',
  'Loading': '加載中',
  'Analyzing': '分析中',
  'Try a sample': '試用範例',
  'Sorry, error occurs when analyzing the URL.': '抱歉，URL解析出錯了。',
  'Upload a photo': '上傳一張圖片',
  "Drag and drop files to the upload box.": '拖拽文件到上傳框',
  'Please select the proper position with portrait.': '請裁剪出合適的人臉部分。',
  'downloading': '正在下載',

}